<template>
  <div class="baidu-ai-success">
    <div class="header">
      <van-icon name="arrow-left" size="17px" class="back-icon" style="padding:0 17px;" @click="submit" />
      <div style="font-size:17px;color:#000;font-weight:bold;">实名认证</div>
      <div></div>
    </div>
    <div class="success-box">
      <van-image
        width="100"
        height="61"
        style="margin-top:75px;margin-bottom:40px;"
        :src="require('/src/assets/image/baiduAI/success-icon.png')"
      />
      <div style="font-size:16px;color:#1E1E1E;margin-bottom:35px;">个人认证成功</div>
    </div>
    <div style="display:flex;justify-content:center;align-items:center;">
      <van-icon name="warning" size="12px" color="#F1BC3F" style="margin-right:8px;" />
      <div style="color:#F1BC3F;font-size:12px;">认证成功后资料不可修改，平台会保护您的个人隐私</div>
    </div>
    <div class="footer">
      <van-button 
        type="warning" 
        color="#EC892E"
        block
        round
        text="确认"
        size="large"
        style="height:38px;"
        @click="submit"
      ></van-button>
    </div>
  </div>
</template>

<script>
import { Button , Icon , Image } from 'vant';
export default {
  components:{
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Image.name]: Image,
  },
  data(){
    return {
      statusBarHeight:0,
    }
  },
  created(){
    if(window.plus) this.handleFindResult();
    else document.addEventListener('plusready',this.handleFindResult,false);
  },
  methods:{
    /* 请求后端查询认证结构 */
    handleFindResult(){
      window.uni.postMessage({
        data: {
          backType:'findResult'
        }
      });
    },
    submit(){
      window.uni.postMessage({
        data: {
          state:200,
          msg:'认证成功'
        }
      });
      window.uni.reLaunch({
        url:'/pages/about/index'
      })
    }
  }
}
</script>

<style scoped lang="scss">
  body {
    background-color: #F5F5F5;
  }
  .baidu-ai-success {
    height: 100vh;
    overflow: hidden;
    .header {
      height: 44px;
      background: #FFF;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .back-icon {
        padding: 0 17px;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        z-index: 9;
        display: flex;
        align-items: center;
      }
    }
    .success-box {
      margin-top: 75px;
      margin: 75px 6px 16px 6px;
      background-color: #FFF;
      border-radius: 20px;
      box-shadow: 0px 1px 6px 1px rgba(30,30,30,0.0800);
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .footer {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 58px;
      z-index: 9;
      padding: 0 50px;
    }
  }
</style>